import React from 'react';
import PropTypes from 'prop-types';
import Button from '@spothero/ui/button';
import CancellationInfo from 'common/cancellation-info/CancellationInfo';
import Price from 'common/price/Price';
import AvailableInventory from './AvailableInventory';

const AirportPurchaseSnapshot = ({
    cancellationAllowed,
    displayPrice,
    currencyType,
    availableTransientInventory,
    checkoutDisabled,
    onCheckoutClick,
}) => {
    return (
        <div className="AirportPurchaseSnapshot">
            <CancellationInfo
                className="AirportPurchaseSnapshot-cancellation-info"
                cancellationAllowed={cancellationAllowed}
                showFreeCancellation
            />
            <div className="AirportPurchaseSnapshot-price-container">
                <div className="AirportPurchaseSnapshot-price-inventory">
                    <div className="AirportPurchaseSnapshot-price">
                        <Price
                            amount={displayPrice}
                            currencyType={currencyType}
                        />
                        <span>/day</span>
                    </div>
                    <AvailableInventory
                        availableTransientInventory={
                            availableTransientInventory
                        }
                    />
                </div>

                <Button
                    color="primary"
                    disabled={checkoutDisabled}
                    onClick={onCheckoutClick}
                >
                    Book Now
                </Button>
            </div>
        </div>
    );
};

AirportPurchaseSnapshot.propTypes = {
    cancellationAllowed: PropTypes.string.isRequired,
    displayPrice: PropTypes.number.isRequired,
    currencyType: PropTypes.string.isRequired,
    availableTransientInventory: PropTypes.number.isRequired,
    checkoutDisabled: PropTypes.bool.isRequired,
    onCheckoutClick: PropTypes.func.isRequired,
};

export default AirportPurchaseSnapshot;
